import { Termin } from '@/domain/termine/shared/types/Termin';
import { Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { TerminPopoverContent } from './TerminPopoverContent';
import { TerminDeleteDialog } from './TerminDeleteDialog';
import { useState } from 'react';

export function TerminPopover({
  termin,
  children,
}: {
  termin: Termin;
  children: React.ReactNode;
}) {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  return (
    <Popover modal>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className="w-85 p-0 shadow-none border-none text-left"
        tabIndex={-1}
        avoidCollisions
        collisionPadding={16}
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
        onInteractOutside={(e) => {
          e.stopPropagation();
        }}>
        <TerminPopoverContent
          termin={termin}
          onDeleteClick={() => setDeleteDialogOpen(true)}
        />
      </PopoverContent>
      <TerminDeleteDialog
        termin={termin}
        open={deleteDialogOpen}
        onOpenChange={setDeleteDialogOpen}
      />
    </Popover>
  );
}
